import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { filter } from 'rxjs';

import { AemNavigationService, HeaderNavigationService } from '@hdms/shared/page-frame/data-access';
import { SizeOption } from '@hdms/shared/ui-core';
import { HashTriggerService, PlatformService, WindowRefService } from '@hdms/shared/util-core';

import { CONSENT_POPUP_HASH } from '../../config/header-config.const';
import { HeaderConfigService } from '../../services';

interface DidomiClient {
  preferences: {
    show: () => void;
  };
}

interface DidomiWin extends Window {
  didomiOnReady: ((client: DidomiClient) => void)[];
}

@Component({
  selector: 'footer[shrd-pf-ft-page-footer]',
  templateUrl: './page-footer.component.html',
  styleUrls: ['./page-footer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageFooterComponent implements OnInit {
  readonly sizeOption = SizeOption;

  readonly footerLinks$ = inject(AemNavigationService).footerLinks$;
  readonly compressed$ = inject(HeaderConfigService).isCompressed$;
  readonly primaryLinks$ = inject(HeaderNavigationService).primaryLinks$;

  readonly isServer = inject(PlatformService).isServer;

  private readonly win = inject<WindowRefService<DidomiWin>>(WindowRefService).nativeWindow;
  private readonly hashTrigger = inject(HashTriggerService);

  ngOnInit(): void {
    !this.isServer && this.listenToCookieConsentTrigger();
  }

  private listenToCookieConsentTrigger(): void {
    this.hashTrigger.registerHash(CONSENT_POPUP_HASH);

    const didomiReady = (this.win.didomiOnReady ||= []);
    didomiReady.push(client => {
      this.hashTrigger.hashChange$
        .pipe(filter(hash => hash === CONSENT_POPUP_HASH))
        .subscribe(_ => client.preferences.show());
    });
  }
}
